import { render, staticRenderFns } from "./organism.swatch.tabs.vue?vue&type=template&id=0632d472"
import script from "./organism.swatch.tabs.vue?vue&type=script&lang=ts"
export * from "./organism.swatch.tabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports